/** Recipes lifted from `trusstor_dashboard/shared/components/TrusstorIconShared/styles.module.scss`.
 *  Trusstor's trade SVGs have hardcoded fills, so colour is applied via a
 *  `filter:` pipeline that maps any source colour to the target. Add more
 *  variants here when needed. */
export const TRADE_ICON_FILTER = {
  /** Pumps any source colour to white — matches trusstor's `.white` rule. */
  white:
    'invert(100%) sepia(0%) saturate(7499%) hue-rotate(58deg) brightness(104%) contrast(103%)',
  /** Pins any source colour to near-black — for icons sitting on the
   *  light-gray profession fallback fill, where a white icon would vanish. */
  dark: 'brightness(0) saturate(100%)',
} as const;
